<div class="plans">
	<div class="_heading font-brand txt-color-primary pb5">
		All plans include:
	</div>

	<section class="header_links">
		<div class="_subheading pb3">
			<img
				class="shortcut_icon"
				src="assets/img/icons/icons-feature-modem.svg"
			/>
	
			<span class="service-title mx2"> Fuss-free plug and play with a Dodo Modem or BYO </span>
		</div>
		<div class="_subheading pb3">
			<img
				class="shortcut_icon"
				src="assets/img/icons/icons-feature-network-status.svg"
			/>
	
			<span class="service-title mx2"> Unlimited Data </span>
		</div>


		<div class="_subheading pb3">
			<img
				class="shortcut_icon"
				src="assets/img/icons/icons-feature-bill.svg"
			/>
	
			<span class="service-title mx2"> No lock-in contracts </span>
		</div>
		<div class="_subheading pb3">
			<img
				class="shortcut_icon"
				src="assets/img/icons/icons-feature-tools.svg"
			/>
	
			<span class="service-title mx2">
				Manage your account online with MyDodo
			</span>
		</div>
	
		<div class="_subheading pb3">
			<img
				class="shortcut_icon"
				src="assets/img/icons/icons-feature-elec-gas.svg"
			/>
	
			<span class="service-title mx2">
				Save up to $10/mth when you bundle with energy<sup class="service-title-sup-text">3</sup>
			</span>
		</div>
	</section>
	
</div>
